<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 品牌介绍 -->
      <div class="footer-brand">
        <img src="../assets/logo_b.png" alt="SkyGPU" class="brand-logo" />
        <!-- <p class="brand-description">
          高性能 GPU 云计算平台，专为 AI 开发者打造。
        </p> -->
      </div>

      <!-- 产品 -->
      <!-- <div class="footer-column">
        <h4 class="column-title">产品</h4>
        <ul class="column-links">
          <li><a href="#">GPU 实例</a></li>
          <li><a href="#">存储服务</a></li>
          <li><a href="#">网络加速</a></li>
          <li><a href="#">镜像市场</a></li>
        </ul>
      </div> -->

      <!-- 支持 -->
      <!-- <div class="footer-column">
        <h4 class="column-title">支持</h4>
        <ul class="column-links">
          <li><a href="#">文档中心</a></li>
          <li><a href="#">API 参考</a></li>
          <li><a href="#">技术论坛</a></li>
          <li><a href="#">联系我们</a></li>
        </ul>
      </div> -->

      <!-- 公司 -->
      <div class="footer-column footer-email">
        <h4 class="column-title">{{ $t("footer.contactEmail") }}</h4>
        <ul class="column-links">
          <li><a href="#">aetrivol@aetrivol.com</a></li>
        </ul>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-copyright">
      <p>© 2024 SkyGPU. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>

<style scoped>
.footer {
  background: #000;
  padding: 10px 20px 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

.footer-container {
  max-width: 1090px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  margin-bottom: 10px;
  align-items: flex-end;
  justify-content: space-around;
}

.footer-email {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

/* 品牌区域 */
.brand-logo {
  width: 410px;
  height: auto;
  margin-bottom: 16px;
  display: block;
}

.brand-description {
  font-size: 14px;
  line-height: 1.6;
  color: #bbb;
  margin: 0;
}

/* 列标题 */
.column-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 16px 0;
  color: #fff;
}

/* 链接列表 */
.column-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.column-links li {
  margin-bottom: 12px;
}

.column-links a {
  font-size: 14px;
  color: #bbb;
  text-decoration: none;
  transition: color 0.2s;
}

.column-links a:hover {
  color: #fff;
}

/* 版权信息 */
.footer-copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #ffffff1a;
}

.footer-copyright p {
  font-size: 12px;
  color: #888;
  margin: 0;
}

/* 响应式 */
@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .brand-logo {
    margin-left: auto;
    margin-right: auto;
  }

  .brand-description {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .column-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }

  .column-links li {
    margin-bottom: 0;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .footer-container {
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 30px;
  }
}
</style>
